module.exports = __webpack_public_path__ + "img/b07a647f191f71ecc8931f35da877d20.f6e9c816.png";